import ChatBubble from './ChatBubble';

export default ChatBubble;
